import { ApiClient, type ApiClientOptions } from '@/infra/api-client'
import {
  type SearchCallCenterContactsRequest,
  type CallCenterContactsResponseResource,
} from '@/features/freshbooks/api/resources/call-center-contacts'
import type { HubspotTrackingTokenResource } from '@/features/freshbooks/api/resources/hubspot-tracking'
import { toURLSearchParams } from '@/utils/url-util'

/**
 * Collection of APIs for Freshbooks.
 */
export class FreshbooksApi {
  readonly hubspot
  readonly callCenter

  constructor(options: ApiClientOptions) {
    this.hubspot = new FreshbooksHubspotApi(options)
    this.callCenter = new FreshbooksCallCenterApi(options)
  }
}

/**
 * HubSpot tracking API.
 */
export class FreshbooksHubspotApi extends ApiClient {
  /**
   * Gets the HubSpot tracking token for the current user.
   *
   * @param signal
   */
  getToken(signal?: AbortSignal): Promise<HubspotTrackingTokenResource> {
    return this._get('hubspot-tracking', undefined, { signal })
  }
}

/**
 * Call center contacts API.
 */
export class FreshbooksCallCenterApi extends ApiClient {
  /**
   * Searches the call center's HubSpot contacts.
   *
   * @param request
   * @param signal
   */
  searchContacts(
    request: SearchCallCenterContactsRequest,
    signal?: AbortSignal,
  ): Promise<CallCenterContactsResponseResource> {
    return this._get(
      'v1/call-center/contacts/search',
      toURLSearchParams({ ...request }),
      { signal },
    )
  }
}
